import React from "react";
import ad1 from "../../assets/Ad (1).png";
import ad2 from "../../assets/Ad (2).png";
import ad3 from "../../assets/Ad (3).png";
import ad4 from "../../assets/Ad (4).png";
import ad5 from "../../assets/Ad (5).png";
import adMain from "../../assets/Ad.png";
import bgHomeS6 from "../../assets/landingPage/bg-home-s6.png";

export default function AdsStreamSectionNew() {
  const ads = [ad1, ad2, ad3, ad4, ad5, adMain];

  // Duplicate the list of ads to make the marquee scroll seamlessly without a gap
  const marqueeAds = [...ads, ...ads];

  return (
    <section className="w-full bg-black py-20 flex flex-col gap-16 overflow-hidden relative">
      {/* Dynamic continuous background blending */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20 pointer-events-none"
        style={{ backgroundImage: `url(${bgHomeS6})` }}
      ></div>

      {/* ================= SECTION 1: CONTINUOUS ADS DISPLAY ================= */}
      <div className="w-full flex flex-col gap-8 relative z-10">
        <div className="max-w-6xl mx-auto px-6 text-center md:text-left">
          <h2 className="text-2xl md:text-3xl font-bold font-oswald  text-white tracking-widest uppercase flex items-center justify-center md:justify-start gap-3">
            <span className="w-2.5 h-2.5 rounded-full  bg-secondary animate-pulse"></span>
            CONTINUOUS ADS STREAM
          </h2>
          <p className="text-gray-400 font-outfit text-sm md:text-base mt-2">
            Showcasing active sponsor advertisements running continuously across the platform.
          </p>
        </div>

        {/* Marquee Wrapper with soft edge gradients */}
        <div className="w-full relative py-6 bg-neutral-950/40 border-y border-neutral-900 select-none">
          {/* Left & Right fading masks */}
          <div className="absolute inset-y-0 left-0 w-16 md:w-32 bg-gradient-to-r from-black via-black/80 to-transparent z-10 pointer-events-none"></div>
          <div className="absolute inset-y-0 right-0 w-16 md:w-32 bg-gradient-to-l from-black via-black/80 to-transparent z-10 pointer-events-none"></div>

          <div className="w-full overflow-hidden flex">
            {/* Scroll Track */}
            <div className="animate-marquee-scroll flex gap-6 md:gap-8 items-center px-4">
              {marqueeAds.map((adImg, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 group relative rounded-xl overflow-hidden border border-neutral-800 bg-neutral-900/60 p-1.5 transition-all duration-300 hover:border-secondary/60 hover:scale-[1.03] hover:shadow-[0_0_20px_rgba(255,140,33,0.15)]"
                >
                  <img
                    src={adImg}
                    alt={`Sponsor Announcement ${index + 1}`}
                    className="h-28 w-48 sm:h-36 sm:w-64 md:h-44 md:w-80 object-cover rounded-lg"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3 pointer-events-none">
                    <span className="text-secondary font-oswald text-xs tracking-wider uppercase font-semibold">
                      Sponsored Ad
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ================= SECTION 2: AD STREAMING CONTACT INFORMATION ================= */}
      <div className="max-w-6xl mx-auto px-6 w-full relative z-10">
        <div className="bg-gradient-to-br from-neutral-950 via-neutral-900 to-neutral-950 border border-neutral-800 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden">
          {/* Background glowing design orb */}
          <div className="absolute -top-24 -right-24 w-48 h-48 rounded-full bg-secondary/10 blur-[80px] pointer-events-none"></div>
          <div className="absolute -bottom-24 -left-24 w-48 h-48 rounded-full bg-blue-500/10 blur-[80px] pointer-events-none"></div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            {/* Left Info Text */}
            <div className="lg:col-span-7 text-center lg:text-left flex flex-col gap-4">
              <span className="text-secondary font-oswald text-xs md:text-sm font-bold tracking-widest uppercase">
                PARTNER WITH BOSS AMONGST BOSSES
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-oswald text-white uppercase tracking-wide leading-none">
                STREAM YOUR BRAND <br className="hidden md:inline" /> ON BAB MEDIA
              </h2>
              <p className="text-gray-300 font-outfit text-sm md:text-base leading-relaxed max-w-xl">
                Promote your original audio, videos, products, or corporate services to our global audience. Benefit from continuous banner ads and streaming placements throughout the platform.
              </p>
            </div>

            {/* Right Contact Cards */}
            <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
              {/* Email Card */}
              <a
                href="mailto:babmedia2023@gmail.com"
                className="flex flex-col items-center justify-center p-6 rounded-2xl border border-neutral-800 bg-black/40 hover:border-secondary hover:bg-neutral-900/40 hover:-translate-y-1 transition-all duration-300 text-center group"
              >
                <div className="w-12 h-12 rounded-xl bg-secondary/10 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <svg
                    className="w-6 h-6 text-secondary"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                    />
                  </svg>
                </div>
                <span className="text-xs text-neutral-400 font-medium font-outfit uppercase tracking-widest mb-1">
                  Email Inquiry
                </span>
                <span className="text-white text-sm font-semibold font-outfit break-all hover:text-secondary transition-colors">
                  babmedia2023@gmail.com
                </span>
              </a>

              {/* Phone/WhatsApp Card */}
              <a
                href="tel:6097739620"
                className="flex flex-col items-center justify-center p-6 rounded-2xl border border-neutral-800 bg-black/40 hover:border-secondary hover:bg-neutral-900/40 hover:-translate-y-1 transition-all duration-300 text-center group"
              >
                <div className="w-12 h-12 rounded-xl bg-secondary/10 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <svg
                    className="w-6 h-6 text-secondary"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.387a12.017 12.017 0 01-4.5-4.5c-.155-.44.01-.928.388-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                    />
                  </svg>
                </div>
                <span className="text-xs text-neutral-400 font-medium font-outfit uppercase tracking-widest mb-1">
                  Call & Stream
                </span>
                <span className="text-white text-sm font-semibold font-outfit hover:text-secondary transition-colors">
                  609-773-9620
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
